<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">乙方公司</p>
        <el-input v-model="searchFrom.renterCompanyName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">关联合同</p>
        <!-- <el-input v-model="searchFrom.contractId" placeholder="请输入" clearable class="inputDiv"></el-input> -->
        <!-- @change="handleContractId" -->
        <el-select v-model="searchFrom.contractId" multiple placeholder="请选择">
          <el-option v-for="item in contractList" :key="item.contractList" :label="item.contractName" :value="item.id">
          </el-option>

        </el-select>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addFormData">凭证录入</el-button>
      <el-button class="searchBtn download" type="success"><a download="凭证录入导入模板.xlsx"
          href="/doc/凭证录入导入模板.xlsx">模板下载</a></el-button>
      <!-- <el-button class="searchBtn" type="primary" @click="exportData">模板导入</el-button> -->
      <el-upload class="upload-demo" action="" :http-request="uploadFile" :show-file-list="false">
        <el-button type="primary" icon="el-icon-upload2">批量导入</el-button>
      </el-upload>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount" @pageChange="handleCurrentChange">
          <template #action="{ row, index }" class="tableButton">
            <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small">编辑
            </el-button>
            <!-- <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
            </el-button> -->
            <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small">删除</el-button>
          </template>
        </TableList>
      </div>
    </div>
  </div>
</template>

<script>
import { noticeInfo } from '@/api/basicInfo'
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
import { baseVoucher, contractQuery } from '@/api/contract'
export default {
  name: 'accountPage',
  components: {
    TableList,
    // uploadFile
  },
  data() {
    return {
      loading: false,
      searchFrom: {
        renterCompanyName: '',
        contractId: ''
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      tableData: [],
      contractList: [],
      statusOptions: [
        {
          label: '未查看',
          value: 0
        },
        {
          label: '已查看',
          value: 1
        },
      ],
      tableColumns: [
        {
          prop: 'renterCompanyName',
          label: '公司名称'
        },
        {
          prop: 'taxBegin',
          label: '纳税开始时间'
        },
        {
          prop: 'taxEnd',
          label: '纳税结束时间  '
        },
        {
          prop: 'taxAmount',
          label: '纳税金额',
        },
        {
          prop: 'contractName',
          label: '关联合同',
        },
        {
          prop: 'contactPerson',
          label: '联系人',
        },
        {
          prop: 'contactPhone',
          label: '联系电话',
        },
        {
          prop: 'action',
          label: '操作',
        },
      ]
    }
  },
  mounted() {
    this.getList()
    this.getData()
  },
  methods: {
    async uploadFile(item) {
      let FromDatas = new FormData()
      FromDatas.append('multipartFile', item.file)
      let result = await baseVoucher('batchImport', FromDatas)
      if (result.code !== 0) return
      this.getData()
      this.$message({ type: 'success', message: '上传成功!' })
    },
    handleFile(imgs) {
      let arrFile = imgs.map(v => v.name).join(',')
      this.addForm.fileUrlList = arrFile
    },
    async getList() {
      // 获取合同
      let res1 = await contractQuery({
                pageNum: 1,
                pageSize: 999,
                contractStatus: 7, // 审批通过
                buildingId: "",
                companyId: "",
                contractName: "",
                contractNumber: ""
            })
            this.contractList = res1.result.records
    },
    getData() {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList() {
      let res = await baseVoucher('query', {
        renterCompanyName: this.searchFrom.renterCompanyName,
        contractId: this.searchFrom.contractId.join(','),
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    addFormData() {
      this.$router.push({
        path: '/contract/addTax',
        query: {
          isEdit: 'add'
        }
      })
      // this.edit = false
      // this.dialogFormVisible = true
      // this.eventControl = '新增公告'
    },
    async viewOrHandle(row, type) {
      this.$router.push({
        path: '/contract/addTax',
        query: {
          isEdit: 'edit',
          id: row.id
        }
      })
    },
    newOldFormContrast(newForm) {
      Object.keys(this.addForm).forEach(key => {
        this.addForm[key] = newForm[key]
      })
      this.addForm.id = newForm.id
    },
    closeData() {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.addForm = this.$options.data.call(this).addForm
    },
    addEventForm() {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            let res = await noticeInfo('update', this.addForm)
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await noticeInfo('add', this.addForm)
            if (res.code === 0) {
              Message.success('新增成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除用户
    deleteFun(row) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await baseVoucher('delete', params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}

.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/

  .stateDiv {
    margin-top: 0.14rem;
    margin-left: .3rem;
    float: left;
  }

  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }

  .inputDiv {
    width: 2.2rem;
    float: left;
  }

  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .3rem;
    /*padding-top: 0.1rem;*/
  }

  .upload-demo {
    margin-left: .3rem;
    display: inline-block;
  }

  .download {
    a {
      color: white;
      text-decoration: none;
    }
  }
}

.table {
  margin-top: .3rem;
  margin-left: .5rem;
  text-align: center;
  width: 14.8rem;

  .searchList {}

  .paginationBody {
    margin-top: .1rem;
  }
}

.formItem {
  // width: 3.2rem;
}

/deep/ .el-dialog {
  width: 30% !important;
}
</style>
